import { Link } from "react-router-dom";
import author1 from "../../assets/images/all-img/blog2/author1.png";
import blog from "../../assets/images/all-img/blog2/dark/blog.png";
import calendar2 from "../../assets/images/svg2/calendar2.svg";
import clock2 from "../../assets/images/svg2/clock2.svg";
 
export default function BlogTopSection() {
	return (
		<div className="fugu--blog-top-section">
			<div className="fugu--blog-top-wrap">
				<div className="fugu--blog-wrap">
					<div className="fugu--blog-thumb">
						<Link to={"single-blog-light"}>
							<img src={blog} alt="" />
						</Link>
						<div className="fugu--blog-badge">Art & Analysis</div>
					</div>
					<div className="fugu--blog-content">
						<div className="fugu--blog-date">
							<ul>
								<li>
									<Link to="#">
										<img src={calendar2} alt="" />
										July 18, 2022
									</Link>
								</li>
								<li>
									<Link to="#">
										<img src={clock2} alt="" />5 min read
									</Link>
								</li>
							</ul>
						</div>
						<div className="fugu--blog-title">
							<Link to={"single-blog-light"}>
								<h3>NFTs & Japanese Culture: a rising, diverse community</h3>
							</Link>
						</div>
						<p>
							It has now been 6 months since the NFT market saw indicators strongly shaken up, with
							additional over hype a month ago...
						</p>
						<div className="fugu--blog-user">
							<div className="fugu--blog-user-thumb">
								<img src={author1} alt="" />
							</div>
							<div className="fugu--blog-user-data">
								<span>Dianne Russell</span>
								<p>Author</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
